import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from "@material-ui/core/styles";
import { useDispatch } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import { toggleNLolayiKeshoyi } from "Constants/Constants";
import MuiRadioGroup from "Components/MuiRadioGroup/MuiRadioGroup";
import MuiButton from "Components/MuiButton/MuiButton";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import Translator from "Languages/Utility/Translator";
import Input from "Components/Input/Input";
import { DialogActions } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import * as R from "ramda";
import { read } from "Helpers/LocalStorage";
import showNotify from "Helpers/Notify";
import {
  getSettingProjectsCustomers,
  getSettingProjectsCustomersProjects,
  insertSettingProject,
} from "Stores/actions/properties/ShopAction";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";

export default function NewProject() {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [formValid, setFormValid] = useState({});
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [checkValid, setCheckValid] = useState(false);

  const [controls, setControls] = useSetState({
    name: {
      type: "text",
      value: "",
      validation: {
        required: true,
      },
    },
    customers: {
      type: "select",
      selectItems: [],
      value: "",
    },
    projects: {
      type: "select",
      selectItems: [],
      value: "",
    },
    selectType: {
      type: "toggle",
      arrayItems: toggleNLolayiKeshoyi,
      value: toggleNLolayiKeshoyi[0],
      validation: {
        required: true,
      },
    },
  });

  const handleDialog = () => setOpenDialog(!openDialog);

  const onEnter = async () => {
    onClear();
  };

  const onClear = async () => {
    setCheckValid(false);
    setFormValid({ name: false });
    setControls({ name: { value: "" } });
    setControls({
      selectType: {
        value: toggleNLolayiKeshoyi[0],
      },
    });
    await get_customers_list();
  };

  const get_customers_list = async () => {
    setLoading(true);
    const data = await dispatch(
      getSettingProjectsCustomers({
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        KeyRequestUser: "",
        All: true,
      }),
    );
    setControls({ customers: { selectItems: data } });
    setControls({ customers: { value: data[0] } });
    await get_project_list(data[0].Id);
    setLoading(false);
  };

  const get_project_list = async (IdCustomer) => {
    setLoading(true);
    const data = await dispatch(
      getSettingProjectsCustomersProjects({
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        IdCustomer,
      }),
    );
    setControls({ projects: { selectItems: data } });
    setControls({ projects: { value: data[0] } });
    setLoading(false);
  };

  const onExit = () => {
    setOpenDialog(false);
  };

  const setValue = async (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
  };

  const onChangeToggle = async (name, key, value, option = null) => {
    setControls({ [name]: { value: value } });
  };

  const autoCompleteHandler = async (e, value) => {
    const controlName = e.target.id.split("-")[0];
    setControls({ [controlName]: { value: value } });
    if (controlName === "customers") {
      await get_project_list(value.Id);
    }
  };

  const onFinish = async (e) => {
    e.preventDefault();
    if (
      !R.isEmpty(formValid) &&
      Object.values(formValid).every((item) => item === true)
    ) {
      const { name, projects, selectType } = controls;
      try {
        const data = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          Name: name.value,
          idProject: projects.value.Id,
          idType: selectType.value.value === "lolayi" ? 1 : 2,
        };
        setLoading(true);
        await dispatch(insertSettingProject(data));
        onExit();
        setLoading(false);
      } catch (e) {
        showNotify({
          text: t("correctFormDataRequired"),
          customClass: "error",
        });
      }
    } else {
      setCheckValid(true);
    }
  };

  return (
    <>
      <MuiButton
        loading={loading}
        color="primary"
        title={<Translator id={"addProject"} />}
        onClick={handleDialog}
        fullwidthOnSm
        disabled={!read("settingShopProject")?.accessRegister}
      />
      <Dialog
        dir={direction}
        open={openDialog}
        TransitionProps={{ onEnter: onEnter, onExit: onExit }}
        onClose={handleDialog}
        fullWidth
        maxWidth="xs"
      >
        <div>
          <div className="dialogHeader">
            <p>{<Translator id={"addProject"} />}</p>
          </div>
          <DialogContent id="content-dialog-manager">
            <BackDropLoading loading={loading} />
            <Grid container spacing={2}>
              {Object.keys(controls).map((key, index) => {
                return (
                  <Grid item xs={12} key={key + index}>
                    {controls[key].type === "toggle" && (
                      <MuiRadioGroup
                        name={key}
                        label={<Translator id={key} />}
                        value={controls[key].value}
                        items={controls[key].arrayItems}
                        onChange={onChangeToggle}
                        translate={true}
                        className="horizontalRadio mb-2"
                      />
                    )}
                    {controls[key].type === "select" && (
                      <MuiAutoComplete
                        options={controls[key].selectItems}
                        label={<Translator id={key} />}
                        value={controls[key].value}
                        id={key}
                        onChange={autoCompleteHandler}
                      />
                    )}
                    {controls[key].type === "text" && (
                      <Input
                        setValue={setValue.bind(this)}
                        value={controls[key].value}
                        name={key}
                        validation={controls[key].validation}
                        label={<Translator id={key} />}
                        type="text"
                        checkValid={checkValid && !formValid[key]}
                      />
                    )}
                  </Grid>
                );
              })}
            </Grid>
          </DialogContent>
          <DialogActions>
            <MuiButton
              loading={loading}
              color="primary"
              title={<Translator id="ezafe_be_list" />}
              onClick={onFinish}
            />
            <MuiButton
              onClick={handleDialog}
              title={<Translator id="enseraf" />}
            />
          </DialogActions>
        </div>
      </Dialog>
    </>
  );
}
